export default "__VITE_ASSET__INKg8MIQ__"